const loadingIndicator = {
    show: () => {
        jQuery(".global-loading-indicator").show();
    },

    hide: () => {
        jQuery(".global-loading-indicator").hide();
    },
};

export default loadingIndicator;
